import {Type, Dom, Ajax, Loc} from 'main.core';
import {Manager} from 'fusion.project.manager';
import {EventEmitter} from 'main.core.events';
import {Button, ButtonColor} from "ui.buttons";
import "sidepanel";

BX.ready(function(){
	if(typeof BX.ProjectCreateButtonInited === "undefined")
	{
		function loadByProject( projectId )
		{
			let profileMenuNode = document.querySelector('.profile-menu-links');

			if ( !Type.isDomNode(profileMenuNode) )
			{
				console.log('.profile-menu-links');
				return;
			}
				
			let projectButtonIdentifier = "project_"+projectId;

			if ( Type.isDomNode(profileMenuNode.querySelector('#'+projectButtonIdentifier)) )
			{
				return;
			}

			let buttonClassList = "ui-btn ui-btn-light-border";

			if ( !Type.isNull(BX.SidePanel.Instance.getSliderByWindow(window)) )
			{
				buttonClassList += " ui-btn-themes";
			}

			if ( Type.isDomNode(profileMenuNode) )
			{
				BX.ajax.runAction(
					'fusion:project.Workgroup.getButtonConfig',
					{
					data: {
						workgroupId: projectId
					}
				}).then(
					(response) => {

						if ( Type.isDomNode(profileMenuNode.querySelector('#'+projectButtonIdentifier)) )
						{
							return;
						}

						if ( !response.data.hasOwnProperty('is_exist') )
						{
							return;
						}

						if ( response.data.is_exist )
						{
							Dom.prepend(Dom.create('a', {
								attrs: {
									id: projectButtonIdentifier,
									href: '#',
									class: buttonClassList,
								},
								events: {
									click: (event) =>
									{
										event.preventDefault();

										Manager.editProject(response.data.id);
									}
								},
								text: Loc.getMessage('FUSION_PROJECT_GOTO_BUTTON'),
							}), profileMenuNode);
						}
						else
						{
							if (
								!Type.isArray(response.data.types)
								||
								response.data.types.length == 0
							)
							{
								return;
							}

							let menuItems = [];

							response.data.types.forEach((item)=>{
								menuItems.push({
									text: item.name,
									onclick: (onclickEvent, onclickItem) => {
										onclickItem.getMenuWindow().close();
										Manager.editProject(0, {
											'type_id': item.id,
											'from_workgroup_id': projectId
										});
									}
								});
							});

							var button = new Button({
								id: "create-project-from-wg-"+projectId,
								text: Loc.getMessage('FUSION_PROJECT_CREATE_BUTTON'),
								round: false,
								dropdown: true,
								menu: {
									items: menuItems,
									closeByEsc: true,
									offsetTop: 5,
								},
								color: ButtonColor.LIGHT_BORDER,
							});

							Dom.prepend(button.getContainer(), profileMenuNode);

							/*
								attrs: {
									id: projectButtonIdentifier,
									href: '#',
									class: buttonClassList,
								},
								events: {
									click: (event) =>
									{
										event.preventDefault();

										Manager.editProject(0, {
											'from_workgroup_id': m.groups.id
										});
									}
								},
								text: Loc.getMessage('FUSION_PROJECT_CREATE_BUTTON')
							}), profileMenuNode);
							*/
						}
					},
					(response) => {

					}
				);
			}
			else
			{
				console.log('profileMenuNode');
			}
		}

		BX.ProjectCreateButtonInited = true;

		const workgroupPageRegexp = new RegExp('/workgroups/group/(?<id>\\d+)/', 'gm')

		let m;

		if ((m = workgroupPageRegexp.exec(window.location.href)) !== null)
		{
			loadByProject( m.groups.id );

			EventEmitter.subscribe(
				'BX.Fusion.Project.Manager:onProjectSave',
				( event ) => {
					BX.cleanNode(BX("project_"+m.groups.id), true);

					loadByProject( m.groups.id );
				}, 
			);
		}
	}
});
